import { equals } from 'ramda'
import { ref } from 'vue'
import { usePolls } from '@/composables/polls/index.js'
import {
  POLLS_GROUP_NAME,
  REGISTRATION_POLLS,
} from './consts.js'

const onboardingPolls = ref(null)
const isBusinessWithoutStaffers = ref(false)

export function useOnboardingPolls () {
  const { loadPollsList, savePoll } = usePolls()

  const loadPolls = async () => {
    onboardingPolls.value = await loadPollsList(POLLS_GROUP_NAME)
  }

  const submitPoll = async ({ pollName, choices }) => {
    try {
      const poll = getPoll(pollName)
      if (!poll || equals(poll.savedChoices, choices)) return

      await savePoll({ pollName, choices })
      poll.savedChoices = choices
      let matchedChoices = []
      choices.forEach(choice => {
        // eslint-disable-next-line eqeqeq
        let matchingChoice = poll.choices?.find(item => item.id == choice)
        if (matchingChoice) {
          matchedChoices.push(matchingChoice.internal_name)
        }
      })
      poll.savedInternalNamesChoices = matchedChoices

      if (pollName === REGISTRATION_POLLS.NUMBER_OF_STAFFERS) {
        const CHOICE_JUST_ME_ID = poll.choices?.find(choice => choice.internal_name === 'just_me')?.id
        isBusinessWithoutStaffers.value = choices.includes(CHOICE_JUST_ME_ID)
      }
      return Promise.resolve()
    } catch ({ response }) {
      return Promise.reject(response.data)
    }
  }

  const getPoll = (pollName) => {
    return onboardingPolls.value?.find(poll => poll.name === pollName)
  }

  return {
    getPoll,
    loadPolls,
    onboardingPolls,
    submitPoll,
    REGISTRATION_POLLS,
    isBusinessWithoutStaffers,
  }
}
